<template>
  <div class="flex w-full animate-pulse flex-col items-center border-b border-neutral-200">
    <div class="h-[43px] w-full rounded-lg bg-gray-200" />
    <div class="flex size-full h-[90px] w-full max-w-screen-xl items-center justify-between gap-6 rounded-lg bg-white px-4 pb-1 desktop:h-[117px]">
      <div class="size-[50px] rounded-lg bg-gray-200 desktop:size-[80px]" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-lg w-20 rounded-lg bg-gray-200 desktop:block" />
      <div class="hidden h-[40px] w-full max-w-96 rounded-lg bg-gray-200 desktop:block" />
      <div class="flex gap-6">
        <div class="size-7 rounded-lg bg-gray-200 desktop:size-10" />
        <div class="size-7 rounded-lg bg-gray-200 desktop:size-10" />
        <div class="size-7 rounded-lg bg-gray-200 desktop:size-10" />
        <div class="size-7 rounded-lg bg-gray-200 desktop:size-10" />
      </div>
    </div>
  </div>
</template>
